/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersoffshorthint3Inputs */

const en_membersoffshorthint3 = /** @type {(inputs: Membersoffshorthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Members" is there once you switch memberships on.`)
};

const de_membersoffshorthint3 = /** @type {(inputs: Membersoffshorthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Mitglieder“ gibt es, sobald du Mitgliedschaften einschaltest.`)
};

/**
* | output |
* | --- |
* | "\"Members\" is there once you switch memberships on." |
*
* @param {Membersoffshorthint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersoffshorthint3 = /** @type {((inputs?: Membersoffshorthint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersoffshorthint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersoffshorthint3(inputs)
	return de_membersoffshorthint3(inputs)
});
export { membersoffshorthint3 as "membersOffShortHint" }